module.exports = __webpack_public_path__ + "img/face-expressionless.f152406c.svg";